import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  GetQpvComponentDetailsQueryKey,
  QpvComponentDetailsData,
  UseGetQpvComponentDetailsParams,
} from './types';

export const getProcessMaterialFinishQueryKey = (
  params: UseGetQpvComponentDetailsParams,
): GetQpvComponentDetailsQueryKey => ['parts', params, 'quote_details'];

export const useGetQpvPageComponentDetails: QueryFunction<
  QpvComponentDetailsData,
  [UseGetQpvComponentDetailsParams],
  GetQpvComponentDetailsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getProcessMaterialFinishQueryKey(params);
  return useQuery<
    QpvComponentDetailsData,
    unknown,
    QpvComponentDetailsData,
    GetQpvComponentDetailsQueryKey
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      params.partUUID
        ? request<QpvComponentDetailsData>(
            `/parts/${params.partUUID}/quote_details`,
            {
              init: {
                method: 'GET',
                signal,
              },
              query: {
                quoteItemId: params.quoteItemId,
              },
            },
          )
        : //Without partUUID, nothing to query. Save a fetch/load on backend
          Promise.resolve({}),
  });
};
